export const MAX_WIDTH_TIKTOK_EMBED = 600;
export const MIN_WIDTH_TIKTOK_EMBED = 325;
export const MAX_HEIGHT_TIKTOK_EMBED = 560;
export const MAX_LENGTH_TRUNCATED_TEXT = 200;
export const IMAGE_WIDTH_EVENT_CARD = 300;
export const IMAGE_HEIGHT_EVENT_CARD = 200;
export const IMAGE_WIDTH_SPONSOR_CARD = 300;
